import { inject } from '@angular/core';

import { LocalizationService } from '@gde-mit/angular-core';

import { UiPreferencesStore } from '@shared/stores/ui-preferences.store';

import { client as ktApiClient } from '@api';

import { ENVIRONMENT } from '@environments/environment';

import { AppConfig, AppSettingsService } from './app-settings.service';

/**
 * Initializes the application by fetching the configuration from `config.json`,
 * setting up the API client, and configuring application-wide settings such as
 * the environment and version number.
 *
 * @returns A promise that resolves when the application is successfully initialized.
 */
export async function initializeApp(): Promise<void> {
  const appSettingsService = inject(AppSettingsService);
  const localizationService = inject(LocalizationService);
  const uiPreferencesStore = inject(UiPreferencesStore);
  uiPreferencesStore.applyThemePreference();
  await localizationService.changeLanguage(ENVIRONMENT.DEFAULT_LANG);

  appSettingsService.appConfig = ENVIRONMENT;
  ktApiClient.setConfig({
    baseUrl: ENVIRONMENT.API_URL ?? '',
    credentials: 'include',
    throwOnError: true,
  });

  appSettingsService.versionNumber = getVersionNumber(ENVIRONMENT);
}

/**
 * Formats the version number string from the application configuration.
 *
 * @param config The application configuration object containing version components.
 * @returns A string representing the version in `major.minor.patch` format.
 */
function getVersionNumber(config: AppConfig): string {
  return 'TODO';
}
